import * as React from 'react';
const { useEffect, useState } = React;
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { Resize, SearchBar } from '../../../../../../layout/layoutHeader/components';
import ShowHideColumns from '../../../../../../layout/layoutHeader/showHideColumns';
import PrintPhysicalDrHeaderControl from '../../PrintPhysicalDr/index';
const PrintPhysicalDrHeaderControlComponent: any = PrintPhysicalDrHeaderControl;
import appConstants from '@appConstants';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles: any = (theme: any) => ({
  iconLayout: {
    float: 'left',
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  headerIconStyles: {
    padding: '10px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer'
  },
});

interface CloseTrailerGridHeaderProps {
  classes: Record<string, string>;
  userData: any;
  gridHeader?: { printPhysicalDr?: boolean };
  stack: {
    config: { content: Array<{ id?: string }>; activeItemIndex?: number };
    layoutManager: { eventHub: { on: (event: string, cb: (api: any) => void) => void; off: (event: string, cb: (api: any) => void) => void } };
    on: (event: string, handler: (component: any) => void) => void;
    off: (event: string, handler: (component: any) => void) => void;
  };
  stackIndex: number;
  headerId: string;
  [key: string]: any;
}

const CloseTrailerGridHeader = (props: CloseTrailerGridHeaderProps) => {
  const { classes, userData, ...other } = props;
  const [gridApi, setGridApi] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(props.stack.config.activeItemIndex || 0);

  const currentGridId = props.stack.config.content[props.stackIndex]?.id;
  const isActiveTab = activeIndex === props.stackIndex;
  const isClosedTrailersGridTab =
    currentGridId === appConstants.gridNames.ClosedTrailersGrid;

  useEffect(() => {
    const gridApiRegistrationEvent = `${props.headerId}_setGridApi`;
    const handleGridApiRegistered = (api: any) => setGridApi(api);
    props.stack.layoutManager.eventHub.on(
      gridApiRegistrationEvent,
      handleGridApiRegistered
    );
    return () => {
      props.stack.layoutManager.eventHub.off(
        gridApiRegistrationEvent,
        handleGridApiRegistered
      );
    };
  }, []);

  useEffect(() => {
    const handleTabSwitch = (component: any) => {
      const newActiveIndex = component?.parent?.config?.activeItemIndex;
      if (newActiveIndex !== undefined) {
        setActiveIndex(newActiveIndex);
      }
    };
    setActiveIndex(props.stack.config.activeItemIndex || 0);
    props.stack.on('activeContentItemChanged', handleTabSwitch);
    return () => {
      props.stack.off('activeContentItemChanged', handleTabSwitch);
    };
  }, [props.stack]);

  if (!isActiveTab || !isClosedTrailersGridTab) {
    return null;
  }

  return (
    <>
      <SearchBar eventHub={props.stack.layoutManager.eventHub} headerId={props.headerId} />
      <ClearAllFilterButton gridApi={gridApi} />
      <div className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}>
        <ShowHideColumns api={gridApi} userData={props.userData} />
      </div>
      {props.gridHeader?.printPhysicalDr ? (
        <PrintPhysicalDrHeaderControlComponent
          eventHub={props.stack.layoutManager.eventHub}
          headerId={props.headerId}
          isClosedTrailersGrid
          cachedGridApi={gridApi}
        />
      ) : null}
      <Resize {...other} />
    </>
  );
};

export default compose(withStyles(styles), withUserProfile)(CloseTrailerGridHeader as React.ComponentType<any>);
